import { Component, useEffect, useState } from "react";
import { Dimensions, FlatList, LogBox, StyleSheet, View } from "react-native"
import { stopCodes } from "./StockAwareTempData";
import { MyButton } from "./buttonsAndControls";
import {
  TabBarVertical,
  TabViewVertical,
  SceneMap,
  type Route,
  type NavigationState,
} from 'react-native-vertical-tab-view';
import VendorView from "./reportPages/Vendor";
import CompanyData from "./reportPages/CompanyData";
import Performance from "./reportPages/Performance";

const darkColour='#2a2d3e';

const initialLayout = {
  height: 0,
  width: Dimensions.get('window').width,
};

class Report extends Component {
  static title = 'Scrollable left vertical bar';
  static backgroundColor = '#3f51b5';
  static appbarElevation = 5;

  componentDidMount() {
    LogBox.ignoreLogs(['Animated: `useNativeDriver`']);
  }
  state = {
    index: 0,
    routes: [
      { key: 'first', title: 'Performance' },
      { key: 'second', title: 'Company Data' },
      { key: 'third', title: 'Vendor & Customer' },
      { key: 'fourth', title: 'Profit' }     
    ],
  };
  _renderTabBar = (props: JSX.IntrinsicAttributes) => (
    <TabBarVertical
      {...props}
      scrollEnabled
      indicatorStyle={styles.indicator}
      style={styles.tabbar}
      tabStyle={styles.tab}
      labelStyle={styles.label}
    />
  );
  render() {
    return (
      <View style={{flex:1}}>
        <TabViewVertical
          style={[styles.container]}
          navigationState={this.state}
          renderScene={SceneMap({
            first: Performance,
            second: CompanyData,
            third: VendorView,
            fourth: VendorView,
          })}
          renderTabBar={this._renderTabBar}
          onIndexChange={(index: number) => this.setState({ index })}
          initialLayout={initialLayout}
        />
      </View>
    ); 
  }
}

export default Report

const styles=StyleSheet.create ({
  container: {
    flex: 1,
  },
  tabbar: {
    backgroundColor: darkColour,
  },
  tab: {
    width: 180,
    height: 60,
  },
  indicator: {
    backgroundColor: 'white',
  },
  label: {
    color:'white', 
    fontFamily:'century gothic', 
    fontSize:13, 
    fontWeight:'500',
  },
  scene:{
    flex:1
  },
})